module.exports = __webpack_public_path__ + "img/no-image.87894f42.jpg";